var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.4304 30.4859V61.5545C60.4304 65.0652 57.6899 67.9211 54.2995 67.9211H6.13087C2.74045 67.9211 0 65.0652 0 61.5545V20.1175C0 16.6068 2.74045 13.751 6.13087 13.751H31.0057C30.9706 13.9329 30.9706 14.1148 30.9706 14.3149C30.9706 21.2271 36.2934 26.8478 42.8986 27.0115V29.2125C42.8986 32.9961 45.8674 36.0702 49.5213 36.0702C53.1752 36.0702 56.1265 32.9961 56.1265 29.2125V28.7396L60.4304 30.4859Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.32812 67.9219V78.9087C15.1955 78.9087 19.9386 73.9792 19.9386 67.9219H9.32812Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.32843 79.9997C8.74872 79.9997 8.27441 79.5086 8.27441 78.9083C8.27441 78.308 8.74872 77.8169 9.32843 77.8169C14.5985 77.8169 18.8849 73.3785 18.8849 67.9215C18.8849 67.3212 19.3592 66.8301 19.9389 66.8301C20.5186 66.8301 20.9929 67.3212 20.9929 67.9215C20.9929 74.5791 15.7579 79.9997 9.32843 79.9997Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.0438 1.69142C59.7978 1.52771 59.4992 1.49133 59.2357 1.60047L52.4548 4.36537H43.2498C37.9445 4.36537 33.623 8.84013 33.623 14.3335C33.623 19.8269 37.9445 24.3017 43.2498 24.3017H45.551V29.213C45.551 31.4868 47.3429 33.3422 49.5387 33.3422C51.7346 33.3422 53.5264 31.4868 53.5264 29.213V24.7201L59.2533 27.0484C59.3587 27.0848 59.4641 27.103 59.5695 27.103C59.7451 27.103 59.9208 27.0484 60.0613 26.9393C60.3073 26.7756 60.4478 26.4845 60.4478 26.1935V2.43722C60.4478 2.12798 60.3073 1.85513 60.0613 1.69142H60.0438ZM49.5212 31.5232C48.2915 31.5232 47.2902 30.4863 47.2902 29.213V24.3017H51.7522V29.213C51.7522 30.4863 50.7508 31.5232 49.5212 31.5232ZM58.6736 24.8838L52.9819 22.5555C52.9819 22.5555 52.9819 22.5555 52.9643 22.5555C52.9643 22.5555 52.8238 22.5191 52.7535 22.5009C52.7183 22.5009 52.6832 22.4827 52.6481 22.4827H43.2673C38.9283 22.4827 35.3973 18.8265 35.3973 14.3335C35.3973 9.84058 38.9283 6.18437 43.2673 6.18437H52.6481C52.7535 6.18437 52.8589 6.16618 52.9643 6.11161L58.6911 3.78328V24.8838H58.6736Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.1116 5.87491C70.7251 5.87491 70.3738 5.62025 70.2684 5.20187C70.1454 4.71074 70.4089 4.21961 70.8832 4.07409L78.8938 1.78214C79.3505 1.65481 79.8424 1.92766 79.9829 2.41879C80.1059 2.90992 79.8424 3.40106 79.3681 3.54658L71.3575 5.83853C71.3575 5.83853 71.1994 5.87491 71.1292 5.87491H71.1116Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M79.1221 26.8847C79.1221 26.8847 78.964 26.8847 78.8938 26.8483L70.8832 24.5563C70.4089 24.429 70.1454 23.9197 70.2684 23.4286C70.3913 22.9374 70.8832 22.6646 71.3575 22.7919L79.3681 25.0839C79.8424 25.2112 80.1059 25.7205 79.9829 26.2116C79.8775 26.6118 79.5262 26.8847 79.1397 26.8847H79.1221Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79.1213 15.0973H71.1108C70.6189 15.0973 70.2324 14.6971 70.2324 14.1878C70.2324 13.6785 70.6189 13.2783 71.1108 13.2783H79.1213C79.6132 13.2783 79.9997 13.6785 79.9997 14.1878C79.9997 14.6971 79.6132 15.0973 79.1213 15.0973Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M68.7048 2.29168V26.3572C68.7048 27.9579 67.2116 29.0675 65.8414 28.4854L62.1348 26.9029V1.72779L65.8414 0.145249C67.2292 -0.436833 68.7048 0.672762 68.7048 2.27349V2.29168Z",
    fill: "#00C880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.4713 55.3154H8.97681C7.49241 55.3154 6.28906 56.5615 6.28906 58.0985V58.1167C6.28906 59.6538 7.49241 60.8998 8.97681 60.8998H51.4713C52.9557 60.8998 54.1591 59.6538 54.1591 58.1167V58.0985C54.1591 56.5615 52.9557 55.3154 51.4713 55.3154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.4713 43.8018H8.97681C7.49241 43.8018 6.28906 45.0478 6.28906 46.5848V46.603C6.28906 48.1401 7.49241 49.3861 8.97681 49.3861H51.4713C52.9557 49.3861 54.1591 48.1401 54.1591 46.603V46.5848C54.1591 45.0478 52.9557 43.8018 51.4713 43.8018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38.3488 32.2871H8.97681C7.49241 32.2871 6.28906 33.5331 6.28906 35.0702V35.0884C6.28906 36.6254 7.49241 37.8715 8.97681 37.8715H38.3488C39.8332 37.8715 41.0365 36.6254 41.0365 35.0884V35.0702C41.0365 33.5331 39.8332 32.2871 38.3488 32.2871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M27.5275 20.791H8.97681C7.49241 20.791 6.28906 22.037 6.28906 23.5741V23.5923C6.28906 25.1293 7.49241 26.3754 8.97681 26.3754H27.5275C29.0119 26.3754 30.2153 25.1293 30.2153 23.5923V23.5741C30.2153 22.037 29.0119 20.791 27.5275 20.791Z",
    fill: "#FFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaign);
export default __webpack_public_path__ + "static/media/icon-campaign.3d4e6915ad7215fe2f29a48f0f2d3da1.svg";
export { ForwardRef as ReactComponent };